import { FloatingFormItem, InputDate, InputText } from '@/components/_common';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Checkbox, Col, Form, Input, Row, Skeleton, TimePicker } from 'antd';
import { FormInstance } from 'antd/es/form/Form';
import { CompanyResourceLimitationPeriodsFormValues } from '../CompanyResourceLimitationPeriodsModal';

interface CompanyResourceLimitationPeriodsFormProps {
  form?: FormInstance<CompanyResourceLimitationPeriodsFormValues>;
  isLoading?: boolean;
  isView?: boolean;
}

export default function CompanyResourceLimitationPeriodsForm({
  form,
  isLoading,
  isView,
}: CompanyResourceLimitationPeriodsFormProps) {
  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  const allResources = Form.useWatch('allResources', form);

  return (
    <>
      <Skeleton active loading={isLoading}>
        <Row gutter={[16, 8]}>
          <Col span={15}>
            <FloatingFormItem
              name="description"
              label="Descrição"
              rules={[defaultEmptyFieldError]}
            >
              <Input disabled={isView} />
            </FloatingFormItem>
          </Col>

          <Col span={6}>
            <FloatingFormItem
              label="Qtde. recurso indisponivel"
              name="resources"
              rules={allResources ? [] : [defaultEmptyFieldError]}
            >
              <InputText onlyNumber disabled={isView || allResources} />
            </FloatingFormItem>
          </Col>

          <Col span={3}>
            <FloatingFormItem name="allResources" valuePropName="checked">
              <Checkbox
                disabled={isView}
                style={{ marginTop: '12px' }}
                onChange={({ target }) => {
                  if (target.checked) {
                    form?.setFieldValue('resources', undefined);
                  }
                }}
              >
                Todos
              </Checkbox>
            </FloatingFormItem>
          </Col>

          <Col span={12}>
            <FloatingFormItem
              name="date"
              label="Data"
              rules={[defaultEmptyFieldError]}
            >
              <InputDate disabled={isView} />
            </FloatingFormItem>
          </Col>

          <Col span={12}>
            <FloatingFormItem
              name="timeRange"
              label="Período"
              rules={[defaultEmptyFieldError]}
            >
              <TimePicker.RangePicker
                disabled={isView}
                format="HH:mm"
                style={{ width: '100%' }}
              />
            </FloatingFormItem>
          </Col>
        </Row>
      </Skeleton>
    </>
  );
}
